import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';
import TransitionContainer from '../../components/Transition/TranstionContainer';

import {
    getExitingCardProps,
    onBackWithinCard,
    onGoToNextCard,
    setExitingCardProps,
    setOverlayPartnerVisible,
    widgetBounce
} from '../Widget/actions';

import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import {
    Container,
    Body,
    Content,
    Sidebar,
    ContentContainer,
    FindRepLink,
    SidebarTitle,
    NotYourRepInfo
} from '../DefaultStyles/Details';

import { MultiImageBlock } from '../../components/Image/MultiImageBlock';
import { isLongText } from '../../components/Shared/commonFunctions';
import CssTransition from '../../components/Transition/CssTransition';
import DetailsForm from '../../components/Email/DetailsForm';
import DetailsFormMultiRepStep1 from '../../components/Email/DetailsFormMultiRepStep1';
import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';
import RepsNotContactable from '../../components/RepsNotContactable';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import {
    ScrollNotice,
    DefaultRepImageURL,
    Title,
    SpinnerContainer
} from '../DefaultStyles/Shared';

import { Placeholders } from '../../utils/fillDynamicText';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { cacheFormData } from '../../utils/formCaching/actions';
import {
    redirectToFrontCard,
    onEmailComplete,
    onEmailMessageChange,
    continueToStep2,
    onBackToRecordVideoSuccess
} from './actions';
import {
    buildCachedAddress,
    relevantRepresentatives,
    joinEnglish,
    districtInfo
} from '../../utils/localRepresentative/parser';

import {
    triggerFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    onDeleteClick,
    onAddClick,
    onShowRepresentatives
} from '../LocalRep/actions';
import { CardTypes, RepresentativeDetails } from '../../utils/enums';
import { pictureUrl } from '../../utils/imageLoading';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { copyFor } from '../../copy/copy';
import { isPortrait } from '../../utils/size';

const ScrollNoticeContainer = styled.div`
    position: absolute;
    cursor: pointer;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    margin: 1em 0;
    align-items: center;
    h3 {
        margin-left: 0.5em;
    }
`;

//This prevents flashing of details screen when byob preview first loads
const byobPreviewStartTime = Date.now();
const byobPreviewValue = () => window.location.hash === '#isByobPreview' &&
                               Date.now() - byobPreviewStartTime < 2000;

class EmailDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scrolled: false,
            scrollButtonVisible: true,
            isSubmitting: false
        };
        this.scrollContainer = React.createRef();
        if (
            props.scrollableDesign &&
            (!!props.emailableReps.length === false || props.isLocalRepLoading) &&
            props.useLocalRepresentative
        ) {
            props.redirectToFrontCard();
        }

        if (
            props.isRecordVideoAction &&
            ((!this.props.isLocalRepLoading && this.props.scrollableDesign) ||
                (this.props.emailableReps.length &&
                    this.props.useLocalRepresentative &&
                    this.props.includesUSSenators))
        ) {
            this.props.continueToStep2({}, true);
        }
    }

    static propTypes = {
        actionCompletedTime: PropTypes.func.isRequired,
        actionIdentifier: PropTypes.string.isRequired,
        activeAction: PropTypes.object.isRequired,
        address: PropTypes.object.isRequired,
        addressValidationError: PropTypes.any,
        answerId: PropTypes.number,
        apiRequestData: PropTypes.object.isRequired,
        articleUrl: PropTypes.string.isRequired,
        backButtonClicked: PropTypes.bool,
        bounceDismissed: PropTypes.bool.isRequired,
        cachedAddress: PropTypes.object,
        cacheFormData: PropTypes.func.isRequired,
        card: PropTypes.object.isRequired,
        cards: PropTypes.array.isRequired,
        cardTitle: PropTypes.string.isRequired,
        continueToStep2: PropTypes.func.isRequired,
        currentFormValues: PropTypes.object,
        emailableReps: PropTypes.array.isRequired,
        emailMessage: PropTypes.string,
        emailSubject: PropTypes.string,
        emailSubmitError: PropTypes.string,
        emailTopic: PropTypes.string,
        endUserLocation: PropTypes.object,
        handleSkippingEndCard: PropTypes.func.isRequired,
        hideFindRepPopup: PropTypes.func.isRequired,
        includesUSSenators: PropTypes.bool.isRequired,
        isDoubleCheckRepPopup: PropTypes.bool,
        isEmailMessageChanged: PropTypes.bool,
        isLocalRepLoading: PropTypes.bool,
        isLocalRepPopupLoading: PropTypes.bool.isRequired,
        isMobileResolution: PropTypes.bool,
        isMultiActionsCard: PropTypes.bool.isRequired,
        isRecordVideoAction: PropTypes.bool,
        isRecordVideoBackTransition: PropTypes.bool,
        isSubmitting: PropTypes.bool.isRequired,
        loadLocalRep: PropTypes.func.isRequired,
        localRepData: PropTypes.object,
        localRepFound: PropTypes.bool.isRequired,
        nextAction: PropTypes.object,
        onAddClick: PropTypes.func.isRequired,
        onBackToRecordVideoSuccess: PropTypes.func.isRequired,
        onBackWithinCard: PropTypes.func.isRequired,
        onDeleteClick: PropTypes.func.isRequired,
        onEmailComplete: PropTypes.func.isRequired,
        onEmailMessageChange: PropTypes.func.isRequired,
        onGoToNextCard: PropTypes.func.isRequired,
        onShowRepresentatives: PropTypes.func.isRequired,
        partnerName: PropTypes.string,
        recipientImages: PropTypes.array,
        recipientMask: PropTypes.string,
        recipientName: PropTypes.string,
        recordVideoEmailData: PropTypes.object,
        redirectToFrontCard: PropTypes.func.isRequired,
        representativeSearch: PropTypes.object,
        response: PropTypes.string,
        scrollableDesign: PropTypes.bool,
        setExitingCardProps: PropTypes.func.isRequired,
        setOverlayPartnerVisible: PropTypes.func.isRequired,
        showFindYouRepPopup: PropTypes.bool.isRequired,
        skipEndCard: PropTypes.bool,
        theme: PropTypes.object.isRequired,
        triggerFindYourRep: PropTypes.func.isRequired,
        useLocalRepresentative: PropTypes.bool,
        widgetBounce: PropTypes.func.isRequired,
        widgetRequestId: PropTypes.string.isRequired
    };

    componentWillUnmount() {
        if (this.scrollContainer.current) {
            this.scrollContainer.current.removeEventListener(
                'scroll',
                this.scrollCallback
            );
        }
    }

    /* Refactor this as well ASAP. We should avoid subscribing to events this way.
       In this particular case, focus and blur are subscribed multiple times and never unsubscribed.
       This means the focus, blur handlers are called multiple times when the user clicks the textarea.
    */
    onTextAreaFocus = (isMobileResolution, isMultiRep) => {
        if (this.props.scrollableDesign) return;
        if (!isMobileResolution) {
            setTimeout(() => {
                var textarea = document.getElementById('textarea');
                if (textarea) {
                    textarea.addEventListener(
                        'focus',
                        function() {
                            if (isMultiRep) {
                                document
                                    .getElementById('notYourRepInfo')
                                    .classList.add('focused');
                            }
                        },
                        true
                    );

                    textarea.addEventListener(
                        'blur',
                        function() {
                            if (isMultiRep) {
                                document
                                    .getElementById('notYourRepInfo')
                                    .classList.remove('focused');
                            }
                        },
                        true
                    );
                }
            }, 50);
        }
    };

    scrollCallback = e => {
        if (e.target.scrollTop > 10) {
            this.setState({ scrolled: true, scrollButtonVisible: false });
        } else {
            this.setState({ scrolled: false, scrollButtonVisible: true });
        }
    };

    handleScrollButtonClick = () => {
        const c = this.scrollContainer.current;
        c.scrollBy({ top: c.scrollHeight - c.clientHeight, behavior: 'smooth' });
        this.setState({ scrolled: true });
        setTimeout(() => {
            this.setState({ scrollButtonVisible: false });
        }, 200);
    };

    async componentDidMount() {
        if (!this.props.localRepFound && this.props.useLocalRepresentative)
            if (byobPreviewValue()) return;
            await this.props.loadLocalRep(
                this.props.endUserLocation,
                this.props.cachedAddress,
                this.props.representativeSearch,
                false,
                true
            );
        // duplicate check for reps on mount to ensure non-US geolocated users aren't subject to more jarring transition.
        if (
            this.props.scrollableDesign &&
            (!!this.props.emailableReps.length === false ||
                this.props.isLocalRepLoading) &&
            this.props.useLocalRepresentative
        ) {
            this.props.redirectToFrontCard();
        }
    }

    render() {
        if (this.scrollContainer.current) {
            this.scrollContainer.current.addEventListener('scroll', this.scrollCallback);
        }

        const repsNotContactable =
            !this.props.emailableReps.length &&
            this.props.useLocalRepresentative &&
            !this.props.isLocalRepLoading;
        const repsLoading = this.props.isLocalRepLoading;

        return (
            <TransitionContainer
                zIndex={5}
                isSubmitting={this.props.isSubmitting || this.state.isSubmitting}
                isBackTransition={
                    this.props.isRecordVideoBackTransition || this.props.backButtonClicked
                }
            >
                <Container>
                    <Overlay />
                    <OverlayPublisher />
                    <OverlayPartner transitionType="right-to-left" />
                    <TransitionGroup>
                        {this.props.emailSubmitError && (
                            <CssTransition key="alert" in={this.props.emailSubmitError}>
                                <ToasterAlert content={this.props.emailSubmitError} />
                            </CssTransition>
                        )}
                        {this.props.addressValidationError && (
                            <CssTransition
                                key="alert"
                                in={this.props.addressValidationError}
                            >
                                <ToasterAlert
                                    content={this.props.addressValidationError}
                                />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                    <Body>
                        <WidgetHeader />
                        {!window.location.hash === '#isByobPreview' && repsLoading && (
                            <SpinnerContainer>
                                <LoadingSpinner
                                    position={'center'}
                                    width={80}
                                    height={80}
                                    stroke={6}
                                    color={this.props.theme.colors.primary}
                                />
                            </SpinnerContainer>
                        )}
                        {repsNotContactable && (
                            <RepsNotContactable
                                scrollableDesign={this.props.scrollableDesign}
                                activeAction={this.props.activeAction}
                                beforeAdvancing={() =>
                                    this.props.setExitingCardProps(
                                        this.props.activeAction.type,
                                        this.props,
                                        this.props.activeAction
                                    )
                                }
                            />
                        )}
                        {/* NON-SCROLLABLE EMAIL */}
                        {!this.props.scrollableDesign &&
                            ((this.props.emailableReps.length >= 1 &&
                                this.props.useLocalRepresentative &&
                                !this.props.includesUSSenators) ||
                                !this.props.useLocalRepresentative) && (
                                <Content scrollableDesign={this.props.scrollableDesign}>
                                    <Sidebar>
                                        <MultiImageBlock
                                            isLocalRepLoading={
                                                this.props.isLocalRepLoading
                                            }
                                            imgSources={this.props.recipientImages}
                                        />
                                        <SidebarTitle>
                                            {copyFor(
                                                'sidebar',
                                                'title',
                                                ['email','recordvideo']
                                                    .includes(this.props.activeAction.type) ?
                                                this.props.activeAction.type :
                                                'recordvideo',
                                                undefined,
                                                {
                                                    recipientName: this.props
                                                        .recipientName
                                                }
                                            )}
                                        </SidebarTitle>
                                        {this.props.localRepFound &&
                                        this.props.useLocalRepresentative && (
                                            <NotYourRepInfo
                                                isUnderImage={true}
                                                isLocalRepLoading={
                                                    this.props.isLocalRepLoading
                                                }
                                            >
                                                {copyFor('findReps', 'notYour', 'email')}{' '}
                                                <br />
                                                <FindRepLink
                                                    onClick={
                                                        this.props.triggerFindYourRep
                                                    }
                                                >
                                                    {copyFor(
                                                        'findReps',
                                                        'clickToFind',
                                                        'email'
                                                    )}
                                                </FindRepLink>
                                            </NotYourRepInfo>
                                        )}
                                    </Sidebar>
                                    <ContentContainer>
                                        <DetailsForm
                                            onSubmit={values => {
                                                this.props.cacheFormData(
                                                    values,
                                                    this.props.actionIdentifier
                                                );
                                                this.props.setExitingCardProps(
                                                    this.props.activeAction.type,
                                                    this.props,
                                                    this.props.activeAction
                                                );
                                                if (this.props.skipEndCard) {
                                                    this.props.handleSkippingEndCard(
                                                        this.props.nextAction,
                                                        this.props.cards,
                                                        this.props.onGoToNextCard
                                                    );
                                                }
                                                this.setState({ isSubmitting: true });
                                                this.props.onEmailComplete(
                                                    this.props.apiRequestData,
                                                    this.props.actionCompletedTime(),
                                                    values,
                                                    this.props.localRepData,
                                                    this.props.isMultiActionsCard,
                                                    this.props.activeAction,
                                                    this.props.recipientMask,
                                                    this.props.activeAction
                                                        .representativeSearch,
                                                    this.props.emailSubject,
                                                    this.props.emailTopic,
                                                    this.props.emailMessage,
                                                    this.props.emailableReps,
                                                    this.props.skipEndCard,
                                                    this.props.isRecordVideoAction,
                                                    this.props.answerId,
                                                    this.props.recordVideoEmailData,
                                                    this.props.partnerName
                                                );
                                            }}
                                            response={this.props.response}
                                            onBackFromRepAction={() => {
                                                if (this.props.isRecordVideoAction) {
                                                    this.props.onBackToRecordVideoSuccess(
                                                        this.props.actionIdentifier,
                                                        this.props.card
                                                    );
                                                } else if (!this.props.bounceDismissed) {
                                                    this.props.widgetBounce(
                                                        true,
                                                        this.props.widgetRequestId,
                                                        this.props.articleUrl,
                                                        this.props.currentFormValues,
                                                        this.props.actionIdentifier
                                                    );
                                                } else {
                                                    this.props.setExitingCardProps(
                                                        this.props.activeAction.type,
                                                        this.props,
                                                        this.props.activeAction
                                                    );
                                                    this.props.onBackWithinCard(
                                                        this.props.actionIdentifier,
                                                        this.props.card
                                                    );
                                                }
                                            }}
                                            isSubmitting={this.props.isSubmitting}
                                            onFocus={this.onTextAreaFocus(
                                                this.props.isMobileResolution,
                                                false
                                            )}
                                            isEmailMessageChanged={
                                                this.props.isEmailMessageChanged
                                            }
                                            onEmailMessageChange={
                                                this.props.onEmailMessageChange
                                            }
                                            recipientName={this.props.recipientName}
                                            scrollableDesign={this.props.scrollableDesign}
                                        />
                                        {isPortrait() ? (
                                            <NotYourRepInfo
                                                isLocalRepLoading={
                                                    this.props.isLocalRepLoading
                                                }
                                                id="notYourRepInfo"
                                            >
                                                <FindRepLink
                                                    onClick={
                                                        this.props.triggerFindYourRep
                                                    }
                                                >
                                                    {copyFor(
                                                        'findReps',
                                                        'notYour',
                                                        'email'
                                                    )}
                                                </FindRepLink>
                                            </NotYourRepInfo>
                                        ) : null}
                                    </ContentContainer>
                                </Content>
                            )}
                        {/* MULTI REP & SCROLLABLE EMAIL */}
                        {(!this.props.isLocalRepLoading && this.props.scrollableDesign) ||
                        (this.props.emailableReps.length &&
                            this.props.useLocalRepresentative &&
                            this.props.includesUSSenators) ? (
                            <Content
                                scrollableDesign={this.props.scrollableDesign}
                                scrollShadow={this.state.scrolled}
                            >
                                <ContentContainer
                                    ref={this.scrollContainer}
                                    scrollableDesign={this.props.scrollableDesign}
                                >
                                    {this.props.localRepFound &&
                                        this.props.useLocalRepresentative &&
                                        !this.props.scrollableDesign && (
                                            <NotYourRepInfo
                                                isLocalRepLoading={
                                                    this.props.isLocalRepLoading
                                                }
                                                id="notYourRepInfo"
                                            >
                                                <FindRepLink
                                                    onClick={
                                                        this.props.triggerFindYourRep
                                                    }
                                                >
                                                    {copyFor(
                                                        'findReps',
                                                        'notYour',
                                                        'email'
                                                    )}
                                                </FindRepLink>
                                            </NotYourRepInfo>
                                        )}
                                    {this.props.scrollableDesign && (
                                        <Row>
                                            <Title
                                                style={{ margin: `5px 0 10px 0` }}
                                                isShortText={
                                                    !isLongText(this.props.cardTitle, 28)
                                                }
                                                isLongText={isLongText(
                                                    this.props.cardTitle,
                                                    60
                                                )}
                                                isExtraLongText={isLongText(
                                                    this.props.cardTitle,
                                                    95
                                                )}
                                                isLocalRepLoading={
                                                    this.props.isLocalRepLoading
                                                }
                                                onClick={e =>
                                                    this.props.setOverlayPartnerVisible(
                                                        true,
                                                        e,
                                                        false
                                                    )
                                                }
                                                dangerouslySetInnerHTML={{
                                                    __html: this.props.cardTitle
                                                }}
                                            />
                                        </Row>
                                    )}

                                    {!this.props.useLocalRepresentative ||
                                    (this.props.useLocalRepresentative &&
                                        this.props.emailableReps.length >= 1 &&
                                        !this.props.includesUSSenators) ? (
                                        <Row>
                                            <MultiImageBlock
                                                size={85}
                                                isLocalRepLoading={
                                                    this.props.isLocalRepLoading
                                                }
                                                imgSources={this.props.recipientImages}
                                            />
                                            <SidebarTitle style={{ marginTop: `0.25em` }}>
                                                {copyFor(
                                                    'sidebar',
                                                    'title',
                                                    'email',
                                                    undefined,
                                                    {
                                                        recipientName: this.props
                                                            .recipientName
                                                    }
                                                )}
                                            </SidebarTitle>
                                        </Row>
                                    ) : null}
                                    <DetailsFormMultiRepStep1
                                        includesUSSenators={this.props.includesUSSenators}
                                        scrollableDesign={this.props.scrollableDesign}
                                        useLocalRepresentative={
                                            this.props.useLocalRepresentative
                                        }
                                        onScroll={this.setScrollState}
                                        onSubmit={values => {
                                            this.props.cacheFormData(
                                                values,
                                                this.props.actionIdentifier
                                            );
                                            this.setState({ isSubmitting: true });
                                            this.props.setExitingCardProps(
                                                this.props.activeAction.type,
                                                this.props,
                                                this.props.activeAction
                                            );
                                            this.props.continueToStep2(values);
                                        }}
                                        onBackFromRepAction={() => {
                                            this.props.setExitingCardProps(
                                                this.props.activeAction.type,
                                                this.props,
                                                this.props.activeAction
                                            );
                                            this.props.onBackWithinCard(
                                                this.props.actionIdentifier,
                                                this.props.card
                                            );
                                        }}
                                        onDeleteClick={data =>
                                            this.props.onDeleteClick(data)
                                        }
                                        onAddClick={data => this.props.onAddClick(data)}
                                        onShowRepresentatives={() =>
                                            this.props.onShowRepresentatives()
                                        }
                                        isSubmitting={this.props.isSubmitting}
                                        onFocus={this.onTextAreaFocus(
                                            this.props.isMobileResolution,
                                            true
                                        )}
                                        isEmailMessageChanged={
                                            this.props.isEmailMessageChanged
                                        }
                                        onEmailMessageChange={
                                            this.props.onEmailMessageChange
                                        }
                                        activeAction={this.props.activeAction}
                                    />
                                </ContentContainer>
                                {!this.props.isLocalRepLoading &&
                                this.props.scrollableDesign &&
                                this.state.scrollButtonVisible ? (
                                    <ScrollNoticeContainer
                                        onClick={this.handleScrollButtonClick}
                                    >
                                        <ScrollNotice theme={this.props.theme}>
                                            <span>{'Scroll down to continue'}</span>
                                        </ScrollNotice>
                                    </ScrollNoticeContainer>
                                ) : null}
                            </Content>
                        ) : null}
                    </Body>
                    {this.props.localRepFound && this.props.useLocalRepresentative && (
                        <TransitionGroup>
                            {this.props.showFindYouRepPopup && (
                                <CssTransition
                                    key="alert"
                                    in={this.props.showFindYouRepPopup}
                                >
                                    <FindLocalRepPopup
                                        address={this.props.address}
                                        hideFindRepPopup={this.props.hideFindRepPopup}
                                        imgSources={this.props.recipientImages}
                                        isDoubleCheckRepPopup={
                                            this.props.isDoubleCheckRepPopup
                                        }
                                        isLocalRepLoading={this.props.isLocalRepLoading}
                                        submitting={this.props.isLocalRepPopupLoading}
                                        onSubmit={() =>
                                            this.props.loadLocalRep(
                                                this.props.endUserLocation,
                                                this.props.address,
                                                this.props.representativeSearch,
                                                true,
                                                true
                                            )
                                        }
                                    />
                                </CssTransition>
                            )}
                        </TransitionGroup>
                    )}
                </Container>
            </TransitionContainer>
        );
    }
}

export default (actionType, route) =>
    connect(
        (state, props) => {
            const exitingProps = getExitingCardProps(
                actionType,
                [route],
                props.location.pathname,
                state
            );
            if (exitingProps) return exitingProps;

            const nextAction = getNextAction(
                state.widget.actions,
                state.widget.activeAction.identifier,
                buildConditionalActionsAnswerHistory(state),
                state.widget.cards
            );

            let reps = state.localRep.localRepData
                ? relevantRepresentatives(
                      state.widget.activeAction.representativeSearch,
                      state.localRep.localRepData.representative
                  )
                : [];
            if (!reps.length && window.location.hash === '#isByobPreview'){
                reps = state.localRep.localRepData.representative || []; //add mock data if no reps?
            }

            const currCard = state.widget.cards[state.widget.activeAction.order - 1];
            const currCardTitle =
                currCard.type === CardTypes.actionChoice
                    ? state.widget.activeAction.name || currCard.heading || ''
                    : currCard.heading || state.widget.activeAction.name || '';

            const country = ((state.localRep.localRepData || {}).address || {}).country;
            const emailableReps = reps.filter(rep => rep.canBeEmailed).slice(0, 3);
            const recipientImages = !!state.widget.activeAction.representativeSearch
                ? emailableReps.map(rep => rep.photoUrl || DefaultRepImageURL(country))
                : pictureUrl(state) || [DefaultRepImageURL(country)];

            return {
                activeAction: state.widget.activeAction,
                actionCompletedTime: getActionCompletedTime(state, 'email'),
                actionIdentifier: state.widget.activeAction.identifier,
                address: state.form.google_autocomplete
                    ? state.form.google_autocomplete.values
                    : {},
                addressValidationError: state.widget.addressValidationError,
                apiRequestData: state.widget.apiRequestData,
                backButtonClicked: state.email.backButtonClicked,
                currentFormValues: (state.form['emailDetailsForm'] || {}).values,
                cachedAddress: buildCachedAddress(
                    state.form.google_autocomplete
                        ? state.form.google_autocomplete.values
                        : state.cachedFormData
                ),
                card: state.widget.cards[state.widget.activeAction.order - 1],
                cards: state.widget.cards,
                cardTitle: currCardTitle
                    .replace(/@articleUrl/g, state.widget.articleUrl)
                    .replace(
                        new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                        state.localRep.localRepData.representative !== undefined
                            ? (state.localRep.localRepData.address || {}).zipCode
                            : ''
                    )
                    .replace(
                        new RegExp(
                            state.widget.activeAction.type === 'tweet'
                                ? Placeholders.TwitterMentionPlaceholder
                                : Placeholders.LocalRepresentative,
                            'g'
                        ),
                        reps.length > 0
                            ? joinEnglish(
                                  reps.map(
                                      rep => `${rep.displayName}${districtInfo(rep)}`
                                  )
                              )
                            : `Speakable`
                    )
                    .replace(
                        new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                        state.localRep.localRepData.representative !== undefined
                            ? joinEnglish(
                                  reps.map(rep => rep.fullName || rep.twitterMention)
                              )
                            : '@Speakable'
                    )
                    .replace(
                        new RegExp(Placeholders.StatePlaceholder, 'g'),
                        (state.localRep.localRepData || {}).stateName || 'your state'
                    )
                    .replace(
                        new RegExp(Placeholders.DistrictPlaceholder, 'g'),
                        (state.localRep.localRepData || {}).district || 'your district'
                    ),
                emailableReps,
                emailSubmitError: state.email.emailSubmitError
                    ? state.email.emailSubmitError.message || state.email.emailSubmitError
                    : state.email.emailSubmitError,
                endUserLocation: state.widget.endUserLocation,
                hiddenReps: state.localRep.hiddenRepresentatives,
                includesUSSenators: !!emailableReps.find(
                    rep =>
                        rep.level === RepresentativeDetails.Level.Country &&
                        rep.role === RepresentativeDetails.Role.LegislatorUpperBody
                ),
                isDoubleCheckRepPopup: state.localRep.isDoubleCheckRepPopup,
                isEmailMessageChanged: state.email.isEmailMessageChanged,
                isLocalRepLoading: byobPreviewValue() || state.localRep.isLocalRepLoading,
                isLocalRepPopupLoading: state.localRep.isLocalRepPopupLoading,
                isMobileResolution: state.widget.isMobileResolution,
                scrollableDesign: state.widget.activeAction.scrollableDesign,
                isMultiActionsCard: currCard.type === CardTypes.multipleActions,
                isStateLevel: !!emailableReps.find(
                    rep => rep.level === RepresentativeDetails.Level.State
                ),
                isSubmitting: state.email.isSubmitting,
                localRepData: state.localRep.localRepData,
                localRepFound: state.localRep.localRepData.representative !== undefined,
                nextAction,
                emailTopic: state.email.topic || '',
                emailSubject: state.email.subject,
                emailMessage: state.email.message || '',
                localRepSetByUserInput: state.localRep.localRepSetByUserInput,
                pictureUrl: pictureUrl(state),
                recipientMask: state.widget.activeAction.recipientMask,
                recipientName: !!state.widget.activeAction.representativeSearch
                    ? joinEnglish(emailableReps.map(rep => rep.displayName))
                    : state.widget.activeAction.recipientMask,
                recipientImages,
                representativeSearch: state.widget.maximumRepresentativeSearch,
                response: state.widget.activeAction.text,
                showFindYouRepPopup: state.localRep.showFindYouRepPopup,
                skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction,
                thankYouText: state.widget.activeAction.thankYouText || '',
                thankYouTitle: state.widget.activeAction.thankYouTitle,
                useLocalRepresentative: !!state.widget.activeAction.representativeSearch,
                widgetRequestId: state.widget.widgetRequestId,
                articleUrl: state.widget.articleUrl,
                bounceDismissed: state.widget.bounceDismissed,
                theme: state.widget.theme,
                //record video
                answerId: state.recordVideo.answerId,
                isRecordVideoAction: state.widget.activeAction.type === 'recordvideo',
                isRecordVideoBackTransition: state.recordVideo.isBackTransition,
                recordVideoEmailData: {
                    subject:
                        state.widget.activeAction.emailSubject ||
                        copyFor('email', 'subject', 'recordvideo'),
                    body:
                        state.widget.activeAction.emailText ||
                        copyFor('email', 'body', 'recordvideo'),
                    videoURL: state.recordVideo.videoURL
                },
                partnerName:
                    state.widget.activeAction.partner &&
                    state.widget.activeAction.partner.name
            };
        },
        {
            cacheFormData,
            continueToStep2,
            handleSkippingEndCard,
            hideFindRepPopup,
            loadLocalRep,
            onAddClick,
            onBackWithinCard,
            onBackToRecordVideoSuccess,
            onDeleteClick,
            onEmailComplete,
            onEmailMessageChange,
            triggerFindYourRep,
            onGoToNextCard,
            onShowRepresentatives,
            setExitingCardProps,
            setOverlayPartnerVisible,
            redirectToFrontCard,
            widgetBounce
        }
    )(EmailDetails);
